import { render, staticRenderFns } from "./SentimentByTerms.vue?vue&type=template&id=cc8e3c64&scoped=true&"
import script from "./SentimentByTerms.vue?vue&type=script&lang=js&"
export * from "./SentimentByTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8e3c64",
  null
  
)

export default component.exports